export default __webpack_public_path__ + "static/media/steering.e2088f69.png";